import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Filter, Plus, Search } from 'lucide-react';
import { MainLayout } from '@/components/layout/MainLayout';
import { PageHeader } from '@/components/layout/PageHeader';
import { UserMenu } from '@/components/common/UserMenu';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { OrdemServicoFormDialog } from '@/components/ordens/OrdemServicoFormDialog';
import { ListaOSAdmin } from '@/components/ordens/ListaOSAdmin';
import {
  OrdensFiltros,
  ORDENS_FILTROS_INICIAL,
  type OrdensFiltrosState,
} from '@/components/ordens/OrdensFiltros';
import { useFeatureTracking } from '@/hooks/useFeatureTracking';

export default function OrdensServico() {
  useFeatureTracking('ordens');
  const { t } = useTranslation();

  const [dialogAberto, setDialogAberto] = useState(false);
  const [filtrosAbertos, setFiltrosAbertos] = useState(false);
  const [termoBusca, setTermoBusca] = useState('');
  const [filtros, setFiltros] = useState<OrdensFiltrosState>(ORDENS_FILTROS_INICIAL);

  return (
    <MainLayout>
      <div className="p-6 flex flex-col gap-5">
        <PageHeader
          titulo={t('orders.title')}
          acoes={
            <>
              <Popover open={filtrosAbertos} onOpenChange={setFiltrosAbertos}>
                <PopoverTrigger asChild>
                  <button type="button" className="ow-btn ow-btn--outline ow-btn--sm">
                    <Filter size={14} />
                    {t('common.filters')}
                  </button>
                </PopoverTrigger>
                <PopoverContent align="end" className="w-80">
                  <OrdensFiltros filtros={filtros} onChange={setFiltros} />
                </PopoverContent>
              </Popover>
              <button
                type="button"
                className="ow-btn ow-btn--primary ow-btn--sm"
                onClick={() => setDialogAberto(true)}
              >
                <Plus size={14} />
                {t('orders.newOrder')}
              </button>
              <UserMenu />
            </>
          }
        />

        <div className="dst-toolbar">
          <label className="dst-toolbar__search">
            <Search size={14} style={{ color: 'hsl(var(--muted-foreground))' }} />
            <input
              type="text"
              placeholder={t('orders.searchPlaceholder')}
              value={termoBusca}
              onChange={(e) => setTermoBusca(e.target.value)}
            />
          </label>
        </div>

        <ListaOSAdmin
          termoBusca={termoBusca}
          prestadorId={filtros.prestadorId}
          periodo={filtros.periodo}
        />
      </div>

      <OrdemServicoFormDialog open={dialogAberto} onOpenChange={setDialogAberto} />
    </MainLayout>
  );
}
